export default __webpack_public_path__ + "static/media/template_business-man__0019_8---ivanLeaw.e9a84e7c.png";